import React from "react";
// COMPONENTS
import { IconTarget, ToneIcon } from "Components/WebsiteTheme/SiteIcons";
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { PILLARS } from "Components/WebsiteTheme/site.data";
// STYLES
import { AboutMissionSection } from "./AboutUs.style";

/** Our Mission, then What We Believe: the same three pillars as on Home, with the longer text. */
const AboutMission = () => (
	<AboutMissionSection className="sm_section">
		<div className="sm_container">
			<div className="am_mission" {...revealProps("up")}>
				<span className="sm_icon sm_icon--green sm_icon--solid" aria-hidden="true">
					<IconTarget />
				</span>
				<div className="am_mission_copy">
					<h2 className="sm_title">Our Mission</h2>
					<p className="sm_lead">
						To help educators reinforce classroom instruction through engaging, teacher-controlled learning experiences that encourage students to practice, persist, and master what
						they’re learning.
					</p>
				</div>
			</div>

			<div className="am_beliefs">
				<div className="am_beliefs_head" {...revealProps("left")}>
					<h2 className="sm_title">What We Believe</h2>
				</div>
				{PILLARS.map((pillar, index) => (
					<article key={pillar.key} className={`am_belief sm_tone--${pillar.tone}`} {...revealProps("up", index + 1)}>
						<ToneIcon iconKey={pillar.key} tone={pillar.tone} />
						<div className="am_belief_copy">
							<h3 className="sm_h4">{pillar.title}</h3>
							<p className="sm_small">{pillar.text}</p>
						</div>
					</article>
				))}
			</div>
		</div>
	</AboutMissionSection>
);

export default AboutMission;
